var OverlayType;
(function (OverlayType) {
    OverlayType[OverlayType["BANK_ID"] = 0] = "BANK_ID";
    OverlayType[OverlayType["CREDIT_ASSESSMENT_BANK_ID"] = 1] = "CREDIT_ASSESSMENT_BANK_ID";
    OverlayType[OverlayType["CREDIT_ASSESSMENT_SCORING"] = 2] = "CREDIT_ASSESSMENT_SCORING";
})(OverlayType || (OverlayType = {}));
export default OverlayType;
